import type { StoreActionApi } from '@atlassian/react-sweet-state';
import type { State } from '../types.tsx';
import type { RuleConfig, RuleSummary } from '../../common/types.tsx';

export const setRuleSummary =
	(ruleSummary: RuleSummary) =>
	({ getState, setState }: StoreActionApi<State>) => {
		setState({
			...getState(),
			ruleSummary,
		});
	};

export const setIssueProperties =
	(issueProperties: RuleConfig) =>
	({ getState, setState }: StoreActionApi<State>) => {
		setState({
			...getState(),
			issueProperties,
		});
	};

export type Actions = {
	setRuleSummary: typeof setRuleSummary;
	setIssueProperties: typeof setIssueProperties;
};

export const actions = {
	setRuleSummary,
	setIssueProperties,
};
